import { Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import TableCell from '@material-ui/core/TableCell';
import PropTypes from 'prop-types';
import React from 'react';
import { globalStyles as styles } from '../../core/style/gstheme';
import GS from '../../grafsync/grafsync';
import TypeDisplay from '../taxonomies/TypeDisplay';
import { isRTL } from '../../core/utils/utils';

const DISABLE_RELATION_DELETION = false;

class ConceptResultDisplay extends React.Component {

  render() {

    const { data, classes, viewLang, defaultLang, graph, display, computeLangStringOutput,
      editMode, ontologyProjectAssociation } = this.props;

    const columnDisplay = display ?
      [...display]
      :
      [true, true, true, true];

    let label = "No label available";
    const displayLang = viewLang && data.prefLabel && data.prefLabel[viewLang] ?
      viewLang
      :
      defaultLang;

    if (data.prefLabel && data.prefLabel[displayLang]) {
      label = Array.isArray(data.prefLabel[displayLang]) ?
        [...data.prefLabel[displayLang]].sort().join(" AND ")
        :
        data.prefLabel[displayLang];
    }

    const classIRIs = GS.getClassIRIs(data.id, graph);
    const classValues = Array.isArray(data.type) ? data.type.filter(c => c !== "Concept") : [];
    const isDeleted = data.pendingDeletion === true;
    const rtl = isRTL(displayLang);
    const basicStyle = {
      minWidth: '200px',
      maxWidth: '300px',
      paddingTop: 12,
      ...(isDeleted) && { color: 'white' }
    };
    const basicStyleRTL = {
      minWidth: '200px',
      maxWidth: '300px',
      paddingTop: 12,
      ...(isDeleted) && { color: 'white' },
      ...(rtl) && { textAlign: "right" }
    };

    return (
      <React.Fragment>
        {columnDisplay[0] &&
          <TableCell className={classes.tableCell} style={basicStyleRTL}>
            <Typography
              data-test={displayLang !== viewLang ? "no-lang-label" : "label"}
              dir={rtl ? "rtl" : null}
              lang={displayLang}
              className={classes.tableCellText}
              style={displayLang !== viewLang ? { color: '#CA4F0C' } : {}}>
              {label}
            </Typography>
          </TableCell>
        }
        {columnDisplay[1] &&
          <TableCell className={classes.tableCell} style={basicStyleRTL}>
            {computeLangStringOutput("altLabel")}
          </TableCell>
        }
        {columnDisplay[2] &&
          <TableCell className={classes.tableCell} style={basicStyle}>
            <TypeDisplay
              graph={graph}
              wrap={false}
              classIRIs={classIRIs}
              ontologyProjectAssociation={ontologyProjectAssociation}
              isReadOnly={!editMode || DISABLE_RELATION_DELETION}
              defaultLang={defaultLang}
              viewLang={viewLang}
              onAddClass={this.onAddClass}
              id={data.id}
              values={classValues} />
          </TableCell>
        }
        {columnDisplay[3] &&
          <TableCell className={classes.tableCell} style={basicStyle}>
            <Typography className={classes.tableCellText}>
              {data.id}
            </Typography>
          </TableCell>
        }
      </React.Fragment>
    );
  }
}

ConceptResultDisplay.defaultProps = {
  ontologyProjectAssociation: []
};

ConceptResultDisplay.propTypes = {
  classes: PropTypes.object,
  display: PropTypes.array,
  editMode: PropTypes.bool,
  computeLangStringOutput: PropTypes.func.isRequired,
  ontologyProjectAssociation: PropTypes.array,
  components: PropTypes.array.isRequired,
  data: PropTypes.object.isRequired,
  graph: PropTypes.string.isRequired,
  project: PropTypes.string.isRequired,
  defaultLang: PropTypes.string.isRequired,
  viewLang: PropTypes.string,
};

export default withStyles(styles)(ConceptResultDisplay);